
import Form from './_.extend';
import stores from "../models/index";
import PostModel from "../models/PostModel";
import PostMessageModel from "../models/PostMessageModel";
import { optionsPostMessageStatus } from "./PostMessageForm";

const optionsPostType = [
    { value: 'incident', label: 'Un-oh' },
    { value: 'maintenance', label: 'System Maintenance' },
    { value: 'release', label: 'New Release' },
    { value: 'information', label: 'News Update' }
];

const optionsPostStatus = [
    { value: 'open', label: 'Open' },
    { value: 'closed', label: 'End' }
];

const getDefaultPostExpiry = () => {
    var date = new Date();
    date.setDate(date.getDate() + 7);
    return date;
};

export default class PostForm extends Form {

    constructor() {
        let statusUpdateOptions = optionsPostMessageStatus.filter(status => status.type === 'incident');        

        super({
            fields: {
                title: {
                    label: 'Title',
                    rules: 'required|string|between:10,255'
                },
                description: {
                    label: 'Description',
                },                
                type: {
                    label: 'Type',
                    value: { value: 'incident', label: 'Un-oh' },
                    rules: 'required',
                    extra: optionsPostType,
                    clearable: false,
                    observers: [{
                        key: 'value',
                        call: ({ form, field, change }) => {
                            // For News or Release, just set the Status to Closed and dont allow user to change it.
                            let newsOrRelease = field.value.value === 'release' || field.value.value === 'information';
                            form.$('status').value = optionsPostStatus[newsOrRelease ? 1 : 0];
                            form.$('status').set('disabled', newsOrRelease);           

                            // For Incidents or Server Maintenance
                            if (!newsOrRelease) {
                                let filteredOptions = optionsPostMessageStatus.filter(status => status.type === field.value.value);
                                form.$('statusUpdate').set('extra', filteredOptions);
                                form.$('statusUpdate').value = filteredOptions[0];
                            }                            
                        },
                    }]
                },
                status: {
                    label: 'Status',
                    value: { value: 'open', label: 'Open' },
                    rules: 'required',
                    clearable: false,
                    extra: optionsPostStatus
                },
                clusters: {
                    label: 'Clusters',
                    rules: 'required',
                    observers: [{
                        key: 'value',
                        call: ({ form, field, change }) => {
                            if (change.newValue !== '') {
                                let allOption = change.newValue.filter(field => field.value === 'ALL');
                                if (allOption.length > 0) {
                                    let allClusters = stores.clusterStore.ClusterOptions.filter(field => field.disabled !== true && field.value !== 'ALL')
                                    field.value = allClusters;
                                }
                            }                            
                        },
                    }]
                },
                expiry: {
                    label: 'Expiry',
                    rules: 'required',
                    value: getDefaultPostExpiry(),
                    extra: { min: (window !== undefined && window.location.search.match('showall') === null) ? new Date() : new Date(0) } // disable min date for testing purpose

                },
                firstUpdate: {
                    label: 'First status update',
                    placeholder: 'Type your update here',
                },
                statusUpdate: {
                    label: 'Status update',
                    extra: statusUpdateOptions,
                    value: statusUpdateOptions[0]
                }
            }
        }, { name: 'Post' });        
    }

    hooks() {
        return {
            onSuccess(form) {
                //alert('Form is valid! Send the request here.');
                // get field values
                console.log('Form Values!', form.values());

                var formData = form.values();
                var newpost = new PostModel(null, formData.title, formData.type.value, formData.status.value, formData.clusters, formData.description, formData.expiry);
                stores.postStore.addPost(newpost, function (post) {                    
                    // For Incidents or Server Maintenance, we dont need long description fields. This field is replaced with the first status update in the same step.
                    let incident = formData.type.value === 'incident',
                        maintenance = formData.type.value === 'maintenance';

                    if ((incident || maintenance) && formData.firstUpdate !== '') {
                        var newpostmessage = new PostMessageModel(post.id, formData.statusUpdate.value, formData.firstUpdate);
                        stores.postStore.addPostMessage(newpostmessage);
                    }
                });                                               

                form.reset(true);
                form.hide();
            },
            onError(form) {
                // get all form errors      
                let errorMessage = '', errors = form.errors();
                for (let field in errors) {
                    if (errors[field] !== null)
                        errorMessage += errors[field] + '\n';
                }
                alert(errorMessage);
            }
        };
    }

    show() {
        const date = getDefaultPostExpiry();
        this.$('expiry').set('default',date);
        this.$('expiry').set('value',date);
        this.display = true;
    }

    onAddMessage(instance) {

        var postId = instance.currentTarget.dataset["refid"];
        //stores.postStore.posts
        alert('onAddMessage for ' + postId);
    }
}


// WEBPACK FOOTER //
// ./src/forms/PostForm.js